@if (fixeviewModel) {
<a class="items-list-item dashboard-item-pos" (click)="openSuiviConso(linkConso)">
  <div class="anchor-align" [ngClass]="{' item-container item-pt-25':  linkConso !== null}">
    <div data-e2e="sub-item-suivi-conso" class="sub-item-picto">
      <div>
        <div class="item-text">
          <span data-e2e="sub-item-label" class="label-picto">{{"dashboard.deviceHome.consumption" | translate}}</span>
          @for (item of fixeviewModel; track item) {
          <div class="picto-item">
            @if (item.picto) {
            <span
              class="item-icon icon-Warning-important icon-size pt-10"
              aria-hidden="true"
              data-e2e="sub-item-picto"
            ></span>
            } @if (item.consumption) {
            <div class="progressbar m-0">
              <div class="progressbar-label" data-e2e="sub-item-consumption">{{item.consumption}}</div>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</a>
}
